/* eslint-disable import/no-commonjs */

module.exports = require("./logger");